export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/home',
  // error page path
  ERROR_PAGE = '/404',
  // 工单详情
  SERVICE_DETAIL = '/service/detail',
  IDENTIFY_DETAIL = '/study/train/identify',
  SERVICE_ALL_DETAIL = '/service/all/detail',
}
